<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              library_books
            </v-icon>
            <span class="title">Data Jenis Surat</span>
          </v-card-title>
          <v-tabs
            v-model="tabsurat"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Jenis Surat
              <v-icon large>library_books</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabsurat">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="4">
                        <v-select
                          :items="liststatus"
                          name="statussurat"
                          v-model="filter.status"
                          label="Status"
                          @change="getJenisSurat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editJenisSurat(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddjenissurat"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addjenissurat.kode_js"
                                :rules="[rules.required]"
                                label="Kode Jenis Surat"
                                name="kode"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addjenissurat.nama_js"
                                :rules="[rules.required]"
                                label="Nama"
                                name="nama"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addjenissurat.deskripsi_js"
                                auto-grow
                                label="Deskripsi jenis surat"
                                rows="1">
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <div class="text-center" v-if="loading.addjenis">
                                <v-progress-circular
                                  :width="3"
                                  color="red"
                                  indeterminate>
                                </v-progress-circular>
                              </div>
                              <v-btn
                                v-if="!loading.addjenis"
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.jenissurat"
      max-width="600px"
      v-if="dmodaldata.jenissurat">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis surat</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatejenissurat"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.jenissurat.kode_js"
                        :rules="[rules.required]"
                        label="Kode jenis surat"
                        name="kode"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.jenissurat.nama_js"
                        :rules="[rules.required]"
                        label="Nama"
                        name="nama"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="dmodaldata.jenissurat.deskripsi_js"
                        auto-grow
                        label="Deskripsi jenis surat"
                        rows="1">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statussurat"
                        v-model="dmodaldata.jenissurat.status_js"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <div class="text-center" v-if="loading.editjenis">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </div>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('jenissurat')">
                        Cancel
                      </v-btn>
                      <v-btn
                        v-if="!loading.editjenis"
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'JenissuratAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      addjenis: false,
      editjenis: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
      status: 'active',
    },
    headers: [
      { text: 'Kode', value: 'kode_js' },
      { text: 'Nama', value: 'nama_js' },
      { text: 'Deskripsi', value: 'deskripsi_js' },
      { text: 'Status', value: 'status_js' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addjenissurat: {
      nama_js: '',
      deskripsi_js: '',
      kode_js: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    tabsurat: null,
    dmodal: {
      jenissurat: false,
    },
    dmodaldata: {
      jenissurat: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getJenisSurat();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJenisSurat() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenissurat/',
            {
              params: {
                status: this.filter.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjenissurat.validate()) {
        if (this.tokenscr) {
          this.loading.addjenis = true;
          this.axios
            .post(
              this.api + '/api/jenissurat/',
              qs.stringify(
                this.addjenissurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjenissurat.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Surat keterangan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJenisSurat();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addjenis = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addjenis = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jenissurat') {
        this.dmodal.jenissurat = false;
      } else {
        this.dmodal.jenissurat = false;
      }
    },
    editJenisSurat(item) {
      this.alertupdate.show = false;
      this.dmodal.jenissurat = true;
      this.dmodaldata.jenissurat = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejenissurat.validate()) {
        if (this.tokenscr) {
          this.loading.editjenis = true;
          this.axios
            .put(
              this.api + '/api/jenissurat/',
              qs.stringify(
                this.dmodaldata.jenissurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jenissurat.nama_js + '" berhasil diubah!';
                  this.getJenisSurat();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editjenis = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editjenis = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
